import { CompanyLegalStatutes } from '../../../../../../types/models/company/company.types';
import { FormItem } from '../../../../../commons/Form/Form.types';
import { ProfileCompanyFormSchema } from './ProfileCompanyForm.types';

export const profileCompanyData: FormItem<ProfileCompanyFormSchema>[][] = [
  [
    {
      name: 'name',
      placeholder: 'Votre entreprise...',
      label: "Nom de l'entreprise",
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
  [
    {
      name: 'legalStatutes',
      placeholder: 'Forme jurique de votre entreprise...',
      label: 'Forme juridique',
      type: 'select',
      id: 'legal-statutes',
      required: false,
      disabled: true,
      options: Object.keys(CompanyLegalStatutes).map((key) => ({
        value: key,
        label: CompanyLegalStatutes[key as keyof typeof CompanyLegalStatutes],
      })),
    },
  ],
  [
    {
      name: 'plan',
      placeholder: "Nombre d'employés de votre entreprise...",
      label: "Nombre d'employés",
      type: 'select',
      id: 'plan',
      required: false,
      disabled: true,
    },
  ],
  [
    {
      name: 'address',
      placeholder: 'Votre adresse...',
      label: 'Adresse',
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
  [
    {
      name: 'city',
      placeholder: 'Votre ville...',
      label: 'Ville',
      type: 'text',
      required: true,
      disabled: false,
    },
    {
      name: 'postalCode',
      placeholder: 'Votre code postal...',
      label: 'Code postal',
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
  [
    {
      name: 'department',
      placeholder: 'Votre département...',
      label: 'Département',
      type: 'text',
      required: true,
      disabled: false,
    },
    {
      name: 'region',
      placeholder: 'Votre région...',
      label: 'Région',
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
  [
    {
      name: 'siret',
      placeholder: 'Numéro siret...',
      label: 'Siret',
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
  // [
  //   {
  //     name: 'firstName_owner',
  //     placeholder: 'Prénom...',
  //     label: 'Prénom du représentant légal',
  //     type: 'text',
  //     required: true,
  //     disabled: false,
  //   },
  //   {
  //     name: 'lastName_owner',
  //     placeholder: 'Nom...',
  //     label: 'Nom du représentant légal',
  //     type: 'text',
  //     required: true,
  //     disabled: false,
  //   },
  // ],
  [
    {
      name: 'email_owner',
      placeholder: 'Email...',
      label: 'Email générique',
      type: 'text',
      required: true,
      disabled: false,
    },
    {
      name: 'phone_owner',
      placeholder: 'N° de téléphone...',
      label: 'N° de téléphone standard',
      type: 'text',
      required: true,
      disabled: false,
    },
  ],
  // [
  //   {
  //     name: 'function_owner',
  //     placeholder: 'Fonction...',
  //     label: 'Fonction du représentant légal',
  //     type: 'text',
  //     required: true,
  //     disabled: false,
  //   },
  // ],
];

export const profileCompanyDisabledData: FormItem<ProfileCompanyFormSchema>[][] = [
  [
    {
      name: 'name',
      placeholder: 'Votre entreprise...',
      label: "Nom de l'entreprise",
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'legalStatutes',
      placeholder: 'Forme jurique de votre entreprise...',
      label: 'Forme juridique',
      type: 'select',
      id: 'legal-statutes',
      required: true,
      disabled: true,
      options: Object.keys(CompanyLegalStatutes).map((key) => ({
        value: key,
        label: CompanyLegalStatutes[key as keyof typeof CompanyLegalStatutes],
      })),
    },
  ],
  [
    {
      name: 'plan',
      placeholder: "Nombre d'employés de votre entreprise...",
      label: "Nombre d'employés",
      type: 'select',
      id: 'plan',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'address',
      placeholder: 'Votre adresse...',
      label: 'Adresse',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'city',
      placeholder: 'Votre ville...',
      label: 'Ville',
      type: 'text',
      required: true,
      disabled: true,
    },
    {
      name: 'postalCode',
      placeholder: 'Votre code postal...',
      label: 'Code postal',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'department',
      placeholder: 'Votre département...',
      label: 'Département',
      type: 'text',
      required: true,
      disabled: true,
    },
    {
      name: 'region',
      placeholder: 'Votre région...',
      label: 'Région',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  [
    {
      name: 'siret',
      placeholder: 'Numéro siret...',
      label: 'Siret',
      type: 'text',
      required: true,
      disabled: true,
    },
  ],
  // [
  //   {
  //     name: 'firstName_owner',
  //     placeholder: 'Prénom...',
  //     label: 'Prénom du représentant légal',
  //     type: 'text',
  //     required: true,
  //     disabled: true,
  //   },
  //   {
  //     name: 'lastName_owner',
  //     placeholder: 'Nom...',
  //     label: 'Nom du représentant légal',
  //     type: 'text',
  //     required: true,
  //     disabled: true,
  //   },
  // ],
  [
    {
      name: 'email_owner',
      placeholder: 'Email...',
      label: 'Email générique',
      type: 'text',
      disabled: true,
    },
    {
      name: 'phone_owner',
      placeholder: 'N° de téléphone...',
      label: 'N° de téléphone standard',
      type: 'text',
      disabled: true,
    },
  ],
  // [
  //   {
  //     name: 'function_owner',
  //     placeholder: 'Fonction...',
  //     label: 'Fonction du représentant légal',
  //     type: 'text',
  //     required: true,
  //     disabled: true,
  //   },
  // ],
];
